import { useTranslation } from "react-i18next";

export default function AppLoading(props: {
    theme?: "dark" | "light";
    tip?: string;
}) {

    const { t} = useTranslation();

    return (
        <div className={`w-screen h-screen flex center  relative ${props.theme}`}>
            <div className={`loading-container`}>
                <div className="loading-flipper"></div>
            </div>
            <div className='color-blue-500 absolute ' style={{top: 'calc(50vh + 50px)'}}>
                <span>{props.tip || t('正在加载') + '...'}</span>
            </div>
        </div>
    )

}
